import TransferForm from './transfer-form';
import "./index.scss";
import Waiting from "./waiting";

const Transfer = () => {
  return (
    <div>
        <TransferForm />
    </div>

  )
}

export default Transfer